import { render, staticRenderFns } from "./thread.vue?vue&type=template&id=1461e7ee&"
import script from "./thread.vue?vue&type=script&lang=js&"
export * from "./thread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports